import { Chip, Grid, Stack } from '@mui/material';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import { green, grey } from '@mui/material/colors';
import PropTypes from 'prop-types';
import * as React from 'react';
import * as Redux from 'react-redux';
import { dateformat, diasDeSemanaUtil } from '../../../../../helpers';
import { diasContinuoClases } from '../../../boletines/BoletinesHelper';

export function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 2 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const AsistenciasDiariasEstudianteComponent = () => {
  const templateStore = Redux.useSelector((state) => state.template);
  const estudiantesStore = Redux.useSelector((state) => state.estudiantes);
  const horariosStore = Redux.useSelector((state) => state.horarios);
  const bloquesPedagogicosStore = Redux.useSelector(
    (state) => state.bloquesPedagogicos,
  );

  const [value, setValue] = React.useState(0);
  const [materias, setMaterias] = React.useState([]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  React.useEffect(() => {
    if (horariosStore.all.length > 0) {
      const materiasArray = horariosStore.all.reduce((acc, el) => {
        if (!acc.find((m) => m.id === el.materia.id)) {
          acc.push(el.materia);
        }
        return acc;
      }, []);
      setMaterias(
        materiasArray.sort((a, b) => a.nombre.localeCompare(b.nombre)),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handleAsistencias = (horario, asistencias) => {
    const last = bloquesPedagogicosStore.all.length - 1;
    const fechaDesde = bloquesPedagogicosStore.all[0].fechaActiva.desde;
    const fechaHasta = bloquesPedagogicosStore.all[last].fechaActiva.hasta;

    const dd = diasDeSemanaUtil.find((el) => el.dia === horario.dia);
    const dias = diasContinuoClases(dd.id, fechaDesde, fechaHasta);

    return dias.map((dia) => {
      const asistencia = asistencias.find((el) => {
        const hIni = dateformat(
          `${dateformat(dia, {})} ${horario.horaInicio}`,
          { format: 'YYYY-MM-DD HH:mm' },
        );
        const hFin = dateformat(`${dateformat(dia, {})} ${horario.horaFinal}`, {
          format: 'YYYY-MM-DD HH:mm',
        });
        const fasi = dateformat(el.fechaHora, { format: 'YYYY-MM-DD HH:mm' });
        const existe = fasi >= hIni && fasi <= hFin;
        return existe;
      });

      return (
        <Grid md={6}>
          <Box
            sx={{
              backgroundColor: asistencia ? green[200] : grey[300],
              px: 1,
              mb: 1,
              mr: 1,
            }}
          >
            <Stack direction="row" justifyContent="space-around">
              <Typography
                variant="body1"
                color="initial"
                align="center"
                sx={{
                  fontWeight: asistencia ? 'bold' : 'normal',
                }}
              >
                {dateformat(dia, { format: 'DD-MM-YYYY' })}
              </Typography>
              {asistencia && (
                <Typography
                  variant="body1"
                  color="initial"
                  align="center"
                  sx={{
                    fontWeight: asistencia ? 'bold' : 'normal',
                  }}
                >
                  {dateformat(asistencia.fechaHora, { format: 'HH:mm a' })}
                </Typography>
              )}
            </Stack>
          </Box>
        </Grid>
      );
    });
  };

  const _handleHorarios = (horario) => {
    const asistencias = estudiantesStore.asistenciasDiarias.filter(
      (el) => el.horario.id === horario.id,
    );
    return (
      <Box
        sx={{
          mb: 2,
        }}
      >
        <Grid container spacing={0}>
          {asistencias.map((el) => {
            return _handleAsistencias(horario, asistencias);
          })}
        </Grid>
      </Box>
    );
  };

  console.log('materias: ', materias);

  return (
    <Box
      sx={{
        flexGrow: 1,
        bgcolor: 'background.paper',
        display: 'flex',
        p: 2,
      }}
    >
      {estudiantesStore.asistenciasDiarias.length === 0 ? (
        <Chip color="primary" label="No tiene asistencias" />
      ) : (
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={value}
          onChange={handleChange}
          aria-label="Materias"
          sx={{
            borderRight: 1,
            borderColor: 'divider',
            minWidth: '180px',
            width: '180px',
          }}
        >
          {materias.map((el, i) => {
            return (
              <Tab
                key={`tabs_${el.id}`}
                label={el.nombre}
                {...a11yProps(i)}
                // sx={{ width: '200px' }}
              />
            );
          })}
        </Tabs>
      )}
      {estudiantesStore.asistenciasDiarias.length !== 0 &&
        materias.map((mat, index) => {
          const horarios = horariosStore.all.filter(
            (el) => el.materia.id === mat.id,
          );
          return (
            <TabPanel key={`tab_panel_${mat.id}`} value={value} index={index}>
              <Box
                sx={{
                  mb: 2,
                  width: templateStore.settings.openSidebar ? '34vw' : '43vw',
                  transition: 'width 0.2s',
                  maxHeight: '70vh',
                  overflowX: 'auto',
                }}
              >
                <Typography variant="body1" color="initial" fontWeight="bold">
                  Docente:{' '}
                  {`${horarios[0].docente.usuario.perfil.pnombre} ${horarios[0].docente.usuario.perfil.papellido}`}
                </Typography>
                {horarios.map((el) => {
                  return (
                    <Box>
                      <Grid container spacing={0} sx={{ mb: 2 }}>
                        <Grid item sx={12} md={6}>
                          Día: {el.dia}
                        </Grid>
                        <Grid item sx={12} md={6}>
                          Desde: {el.horaInicio} Hasta: {el.horaFinal}
                        </Grid>
                      </Grid>
                      {_handleHorarios(el)}
                    </Box>
                  );
                })}
              </Box>
            </TabPanel>
          );
        })}
    </Box>
  );
};

export default AsistenciasDiariasEstudianteComponent;
